import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ShowComponent } from './show/show.component';
import { ShowMasterComponent } from './show-master/show-master.component';
import { ShowMasterDetailComponent } from './show-master-detail/show-master-detail.component';
import { ShowNewspaperComponent } from './show-newspaper/show-newspaper.component';
import { FmApiService } from './FMAPI/fm-api.service';
import { HttpClientModule } from '@angular/common/http';
import { BusyIndicatorComponent } from './busy-indicator/busy-indicator.component';
import { FormsModule } from '@angular/forms';
import { BusyIndicatorService } from './busy-indicator/busy-indicator.service';
import { NotificationComponent } from './notification/notification.component';
import { NotificationService } from './notification/notification.service';
import { LocalStorageService } from './local-storage.service';
import { UserPreferenceService } from './user-preference/user-preference.service';
import { FavoriteEditComponent } from './favorite-edit/favorite-edit.component';
import { UiSrefNotActiveDirective } from './directives/ui-sref-not-active.directive';

@NgModule({
  declarations: [
    AppComponent,
    ShowComponent,
    ShowMasterComponent,
    ShowMasterDetailComponent,
    ShowNewspaperComponent,
    BusyIndicatorComponent,
    NotificationComponent,
    FavoriteEditComponent,
    UiSrefNotActiveDirective
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    FormsModule,
    AppRoutingModule
  ],
  providers: [
    FmApiService,
    BusyIndicatorService,
    NotificationService,
    LocalStorageService,
    UserPreferenceService
  ],
  bootstrap: [
    AppComponent
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// D:/OTHERS/FirstmediaShowSchedule/src/app/app.module.ts